import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn, Router } from '@angular/router';
import { SsoService } from '@devinforius/i-sso';

export const AuthRedirectGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const ssoService = inject(SsoService);
    const router = inject(Router);

    if (ssoService.hasValidAccessToken()) {
        return true;
    }

    localStorage.setItem('post_login_redirect_uri', state.url);

    router.navigateByUrl('/public/home');
    return false;
};